import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

export interface MyAccountMenuItemProps {
    withFlag?: boolean;
    className?: string;
    marginLeft?: number;
}

export const MyAccountMenuItem = (props: MyAccountMenuItemProps) => {
    const withFlag = props.withFlag ?? true;

    return (
        <LeftMenuItem
            icon="pe-7s-id"
            label="My Account"
            to="/profile"
            flagCode={
                withFlag ? NotificationFlagsCategories.AccountCode : undefined
            }
            className={props.className}
            marginLeft={props.marginLeft}
            trackingAction="My Account"
            gtmCategory="My Account"
        />
    );
};
